import React, { useEffect } from "react";
import "./ThreadFooter.css";
import { Avatar } from "@nextui-org/avatar";
import { Button, Textarea } from "@nextui-org/react";
import { useStreamContext, useFeedContext } from "react-activity-feed";

import avatarImage from "../../assets/avatarImage.svg";
import { getInitialLetters } from "../../helpers/user";
import { useCommentStore } from "../../stores/commentStore";

export const ThreadFooterHeight = 56;

export function ThreadFooter({ activity }) {
  const { userData } = useStreamContext();
  const { comments, setComments } = useCommentStore();
  const feed = useFeedContext();

  const userName = userData?.name;

  const [replyText, setReplyText] = React.useState(comments?.hasOwnProperty(activity.id) ? comments[activity.id] : "");

  useEffect(() => {
    setReplyText(comments?.hasOwnProperty(activity.id) ? comments[activity.id] : "")
  }, []);

  const replyDisabled = () => !replyText || replyText === "";

  const postReply = () => {
    if (replyDisabled()) return;

    feed.onAddReaction("comment", activity.id, {
      text: replyText,
    });

    onSetReplyTextHandle("");
  };

  const onSetReplyTextHandle = (text) => {
    setReplyText(text);
    setComments(activity.id, text);
  }

  return (
    <div
      className="ThreadFooterContainer"
      style={{
        minHeight: `${ThreadFooterHeight}px`,
        position: "absolute",
        bottom: 0,
        left: 0,
        width: "100%",
        zIndex: 10,
      }}
    >
      <div className="ThreadFooterAvatarContainer">
        <Avatar
          src={avatarImage}
          style={{ backgroundColor: "transparent", position: "absolute" }}
          size="sm"
        />
        <h4
          className="uppercase"
          style={{ position: "absolute", fontSize: "0.75rem" }}
        >{`${getInitialLetters(userName)}`}</h4>
      </div>
      <div className="w-full mr-2.5">
        <Textarea
          variant={"bordered"}
          placeholder="Post reply"
          minRows={1}
          maxRows={5}
          classNames={{
            input: "textarea-input",
            inputWrapper: "textarea-input-wrapper",
          }}
          value={replyText}
          onChange={(e) => onSetReplyTextHandle(e.target.value)}
        />
      </div>

      <Button
        className="ReplyButton mr-2"
        size="small"
        onClick={postReply}
        isDisabled={replyDisabled()}
      >
        Reply
      </Button>
    </div>
  );
}
